import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import DataTable from "react-data-table-component";
import Header_Company from "../../Components/Header_Company";
import Header_Supervisor from "../../Components/Header_Supervisor";

import { BASE_URL } from "../../Config";
import AssignPackageModal from "../../Components/CompanyDetails/AssignPackageModal";

const AgentPackagesView = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [userRole, setuserRole] = useState(false);

  useEffect(() => {
    const storedUserData = sessionStorage.getItem("user");
    if (storedUserData) {
      try {
        const userData = JSON.parse(storedUserData);
        setUserId(userData.companyId);
        setuserRole(userData.userRole);
      } catch (error) {
        Swal.fire("Error", "Failed to parse user data.", "error");
      }
    } else {
      Swal.fire("Session Expired", "Please log in again.", "warning");
    }
  }, []);

  const fetchPackages = async () => {
    if (!userId) return;

    setLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}AgentPackages?id=${userId}`,
        { headers: { accept: "*/*" } }
      );

      const res = response.data;

      if (res.responseCode === "0000") {
        setPackages(res.data || []);
      } else if (res.responseCode === "0003") {
        Swal.fire("No Packages Found", res.message, "info");
      } else if (res.responseCode === "0004") {
        Swal.fire("Error", res.message, "error");
      } else {
        Swal.fire(
          "Unexpected Response",
          "Unrecognized response code.",
          "warning"
        );
      }
    } catch (error) {
      console.error("Error fetching packages", error);
      Swal.fire("Error", "An error occurred while fetching packages.", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPackages();
  }, [userId]);

  const handleEditPackage = async (pkgId) => {
    try {
      const response = await axios.post(
        `${BASE_URL}EditAgentPackages?pkgId=${pkgId}`,
        {},
        { headers: { accept: "*/*" } }
      );

      const res = response.data;

      if (res.responseCode === "0000") {
        Swal.fire(
          "Success",
          res.message || "Package updated successfully.",
          "success"
        );
        fetchPackages();
      } else {
        Swal.fire("Error", res.message || "Something went wrong.", "error");
      }
    } catch (error) {
      console.error("Error editing package", error);
      const errorMessage =
        error.response?.data?.message ||
        "An error occurred while editing the package.";
      Swal.fire("Error", errorMessage, "error");
    }
  };

  const columns = [
    {
      name: "Agent Name",
      selector: (row) => row.agentName,
      sortable: true,
    },
    {
      name: "Package Name",
      selector: (row) => row.packageName,
      sortable: true,
    },
    {
      name: "Package Status",
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => (
        <span
          className={`badge ${row.status === "Active" ? "bg-success" : "bg-danger"
            }`}
        >
          {row.status}
        </span>
      ),
    },
    {
      name: "Package Price",
      selector: (row) => row.packagePrice,
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <button
          className={`btn btn-sm ${row.status === "Active" ? "btn-danger" : "btn-success"
            } mx-1`}
          onClick={() => handleEditPackage(row.id)}
        >
          {row.status === "Active" ? "Deactivate" : "Activate"}
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <>
      {userRole === "Company" ? <Header_Company /> : <Header_Supervisor />}

      <div className="container-fluid mt-4">
        <div className="row justify-content-center">
          <div className="col-12 col-md-10 col-lg-8">
            <div className="card">
              <div className="card-header position-relative text-center">
                <h2 className="mb-0">Agent Packages</h2>
                <button
                  className="btn btn-primary position-absolute"
                  style={{
                    top: "50%",
                    right: "15px",
                    transform: "translateY(-50%)",
                  }}
                  onClick={() => setModalIsOpen(true)}
                >
                  + Assign Package
                </button>
              </div>

              <div className="card-body">
                {loading ? (
                  <div className="text-center">
                    <div
                      className="spinner-border text-primary"
                      role="status"
                    />
                    <p>Loading packages...</p>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <DataTable
                      columns={columns}
                      data={packages}
                      pagination
                      highlightOnHover
                      responsive
                      striped
                      noDataComponent="No packages available"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {modalIsOpen && (
          <AssignPackageModal
            isOpen={modalIsOpen}
            onRequestClose={() => setModalIsOpen(false)}
            userId={userId}
          />
        )}
      </div>
    </>
  );
};

export default AgentPackagesView;